<template>
    <div class="swiper-container">
        <div class="swiper news-carousel">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="news in newsletterArticle" :key="news.displayText">
                    <a target="_top" :href="news.chassisURL">
                        <span class="article-collection-name">
                            <span>
                                {{news.displayText}}
                                <span class="chevron-right-icon">Read more</span>
                            </span>
                        </span>
                        <img :src="getImageUrl(news.thumbnailImage.urls[0])" alt="" />
                    </a>
                </div>
            </div>
        </div>
        <div class="swiper-button-next swiper-navigation-yellow"></div>
        <div class="swiper-button-prev swiper-navigation-yellow"></div>
    </div>
</template>

<script>
    import gql from 'graphql-tag';
    import Swiper from 'swiper';
    import SwiperCore, { Navigation } from 'swiper/core';
    SwiperCore.use([Navigation]);

    export default {
        data() {
            return {
                swiper: null,
                cmsBaseUrl: process.env.VUE_APP_CMS_BASE_URL,
            }
        },
        watch: {
            newsletterArticle: {
                handler() {
                    this.$nextTick(() => {
                        this.reinnitSwiper();
                    })
                }
            }
        },
        mounted() {
            this.swiper = new Swiper(".news-carousel", {
                slidesPerView: "auto",
                spaceBetween: 15,
                navigation: {
                    nextEl: "#HomeNews .swiper-button-next",
                    prevEl: "#HomeNews .swiper-button-prev",
                },
                breakpoints: {
                    992: {
                        slidesPerView: 3,
                    }
                }
            });
        },
        apollo: {
            newsletterArticle: {
                query: gql`
                    {
                      newsletterArticle(orderBy: {publishedUtc: DESC}, first: 10) {
                        displayText
                        chassisURL
                        thumbnailImage {
                          urls
                        }
                      }
                    }
                `,
            }
        },
        methods: {
            reinnitSwiper() {
                this.swiper.update();
            },
            getBaseUrl() {
                var IS_STAG = window.location.host.indexOf("inprogress") > -1 || window.location.host.indexOf("localhost") > -1;
                if (IS_STAG) this.cmsBaseUrl = 'https://dunloptyres-oc-qa.azurewebsites.net';

                return this.cmsBaseUrl;
            },
            getImageUrl(imagePath) {
                var fullPath = this.getBaseUrl() + imagePath;
                return fullPath;
            }
        }
    };
</script>